import type {
  CartQuery,
  ProductQuery,
  ProductsPreviewQuery,
} from '@/types/graphql';

export type CartAttributeInput = {
  key: string;
  value: string;
};

export type CartItemInput = {
  merchandiseId: string;
  quantity: number;
  sellingPlanId?: string;
  attributes?: CartAttributeInput[];
};

export type Product = ProductQuery['product'];

export type Cart = CartQuery['cart'];
export type ProductVariant = NonNullable<Product>['variants']['nodes'][number];
export type CartItem = NonNullable<Cart>['lines']['edges'][number]['node'];
export type CartSubtotal = NonNullable<Cart>['cost'];
type CartItemMerch = CartItem['merchandise'];
export type CartProductPrice = CartItemMerch['price'];
export type CartProductData = CartItemMerch['product'];
export type CartProductImage = CartItemMerch['image'];

export type ProductPreviews = ProductsPreviewQuery['nodes'];
export type ProductPreviewItem = ProductPreviews[number];

export enum SHOPIFY_ENV {
  DEV = 'DEV',
  PROD = 'PROD',
}
